module.exports = __webpack_public_path__ + "img/dl3.bc771f7e.png";